const TOOLTIP_KEYS = {
  FLOATING_ARROW: "slapie-tooltip-floating-arrow-shown",
  FLOATING_TUTORIAL: "slapie-tooltip-floating-tutorial-shown",
  NEW_ORDER_PAYMENT_HINT: "slapie-tooltip-new-order-payment-hint-shown",
};

export const hasTooltipBeenShown = (tooltipKey) => {
  try {
    return localStorage.getItem(TOOLTIP_KEYS[tooltipKey]) === "true";
  } catch (err) {
    console.error("Error checking tooltip status:", err);
    return true; // If error, assume shown to avoid annoyance
  }
};

export const markTooltipAsShown = (tooltipKey) => {
  try {
    localStorage.setItem(TOOLTIP_KEYS[tooltipKey], "true");
  } catch (err) {
    console.error("Error marking tooltip as shown:", err);
  }
};

export const resetTooltips = () => {
  try {
    Object.values(TOOLTIP_KEYS).forEach((key) => {
      localStorage.removeItem(key);
    });
  } catch (err) {
    console.error("Error resetting tooltips:", err);
  }
};

export { TOOLTIP_KEYS };
